<template lang="pug">
div
  v-card.elevation-0
    file(v-for='file in files', :file='file', @remove='removeFile', :key='file.id')

    v-card.pa-3(v-if='files.length === 0') Er zijn nog geen bijlagen toegevoegd

    v-progress-linear.ma-0(indeterminate, color='primary', height='5', v-if='loading')

  v-file(@change='addFile', accept='application/pdf')
    v-btn(flat)
      v-icon.mr-2(color='primary') fas fa-plus
      span Bijlage toevoegen

</template>

<script>
import VFile from '@outluch/v-file'

export default {
  components: {
    VFile,
    File: require('@/components/File').default
  },

  data () {
    return {
      files: [],
      loading: true
    }
  },

  methods: {
    async loadFiles () {
      this.loading = true

      this.files = await this.$store.dispatch('graphqlQuery', {
        name: 'getOrganizationFiles',
        variables: {
          orgId: this.$store.state.organization.currentOrgId
        }
      })

      this.loading = false
    },

    async addFile (file) {
      if (!file) return

      this.loading = true

      const url = await this.$store.dispatch('files/upload', {
        type: 'organization_file',
        data: file,
        extra: {
          orgId: this.$store.state.organization.currentOrgId
        }
      })

      await this.$store.dispatch('graphqlMutation', {
        name: 'addOrganizationFile',
        variables: {
          orgId: this.$store.state.organization.currentOrgId,
          url,
          filename: file.name
        },
        deleteCacheQueries: ['getOrganizationFiles']
      })

      this.loading = false

      await this.loadFiles()
    },

    async removeFile (file) {
      this.loading = true

      await this.$store.dispatch('graphqlMutation', {
        name: 'removeOrganizationFile',
        variables: {
          orgId: this.$store.state.organization.currentOrgId,
          fileId: file.id
        },
        deleteCacheQueries: ['getOrganizationFiles']
      })

      this.files.splice(this.files.findIndex(x => x.id === file.id), 1)

      this.loading = false
    }
  },

  async created () {
    this.loadFiles()
  }
}
</script>

<style lang="scss" scoped>
</style>
